/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
.m-card {
  position: relative;
}
.m-card:not(.m-card--breakout) > a {
  padding: 1.875em;
}
.m-card:not(.m-card--breakout) .m-card__footer {
  margin-top: auto;
}
.m-card:not(.m-card--breakout, .m-card--topic) {
  background: var(--white);
  border: 1px solid var(--gray-20);
  border-bottom-width: 3px;
  padding: 1.875em;
}
.m-card:not(.m-card--breakout, .m-card--topic), .m-card > a {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-basis: 0;
  box-sizing: border-box;
  height: 100%;
}
.m-card a:focus {
  outline-offset: 2px;
}
.m-card__footer > a {
  font-weight: 500;
  border-bottom-width: 1px;
}
@media only all and (max-width: 56.3125em) {
  .m-card__heading {
    margin-bottom: 0.6818181818em;
    font-size: 1.375em;
    font-weight: normal;
    letter-spacing: inherit;
    line-height: 1.25;
    text-transform: inherit;
  }
  p + .m-card__heading, ul + .m-card__heading, ol + .m-card__heading, dl + .m-card__heading, figure + .m-card__heading, img + .m-card__heading, table + .m-card__heading, blockquote + .m-card__heading, h1 + .m-card__heading, .h1 + .m-card__heading, h2 + .m-card__heading, .h2 + .m-card__heading, h4 + .m-card__heading, .h4 + .m-card__heading, h5 + .m-card__heading, .h5 + .m-card__heading, h6 + .m-card__heading, .h6 + .m-card__heading {
    margin-top: 1.3636363636em;
  }
}
@media only all and (max-width: 56.3125em) and (max-width: 37.5em) {
  .m-card__heading {
    margin-bottom: 0.8333333333em;
    font-size: 1.125em;
    font-weight: 500;
    letter-spacing: inherit;
    line-height: 1.25;
    text-transform: inherit;
  }
}
.m-card__heading > a {
  color: var(--black);
}
.m-card__heading > a:hover {
  color: var(--pacific);
}
.m-card__heading > a .m-card__icon {
  font-size: 1em;
  margin-bottom: 0;
  padding-right: 0.46875em;
}
.m-card__heading > a .m-card__icon, .m-card__heading > a span {
  display: table-cell;
}
.m-card > .m-list {
  margin-top: 10px;
  margin-bottom: 30px;
}
.m-card--topic {
  text-align: center;
  width: 170px;
  background: var(--white);
}
.m-card--topic > a {
  border: 1px solid var(--gray-20);
  border-bottom-width: 3px;
}
.m-card--topic .m-card__icon {
  font-size: 1.875em;
  color: var(--green);
  margin-bottom: 0.3125em;
}
.m-card--topic:hover > a {
  box-shadow: 0 2px 0 0 inset var(--gray-20), 2px 0 0 0 inset var(--gray-20), -2px 0 0 0 inset var(--gray-20);
}
.m-card--topic:hover::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 1px;
  height: 5px;
  width: 100%;
  background: var(--green);
}
.m-card--topic .m-card__footer > span {
  display: inline;
  border-width: 0;
  border-bottom-width: 1px;
  border-color: var(--pacific);
  border-style: dotted;
  font-weight: 500;
  color: var(--pacific);
  text-decoration: none;
}
.m-card--topic > a:visited .m-card__footer > span {
  border-color: var(--teal);
  color: var(--teal);
}
.m-card--topic:hover .m-card__footer > span {
  border-style: solid;
  border-color: var(--pacific-dark);
  color: var(--pacific-dark);
}
.m-card--topic > a:focus .m-card__footer > span {
  border-color: var(--pacific-dark);
  color: var(--pacific-dark);
}
.m-card--topic > a:active .m-card__footer > span {
  border-color: var(--pacific-dark);
  border-style: solid;
  color: var(--pacific-dark);
}
.m-card--topic-action .m-card__icon {
  color: var(--pacific);
}
.m-card--breakout {
  min-width: 210px;
  text-align: center;
}
.m-card--breakout > a {
  padding-top: 60px;
}
.m-card--breakout .m-card__inner-wrapper {
  position: relative;
  z-index: 0;
  min-height: 135px;
  background: var(--gray-5);
  border: 1px solid var(--gray-20);
  border-bottom-width: 3px;
}
.m-card--breakout .m-card__img {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 50%;
  width: 210px;
  height: 120px;
  margin-left: -105px;
}
.m-card--breakout .m-card__footer {
  margin-top: 84px;
}
.m-card--breakout:hover .m-card__inner-wrapper {
  box-shadow: 0 2px 0 0 inset var(--gray-20), 2px 0 0 0 inset var(--gray-20), -2px 0 0 0 inset var(--gray-20);
}
.m-card--breakout:hover::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 1px;
  height: 5px;
  width: 100%;
  background: var(--green);
}
.m-card--breakout .m-card__footer > span {
  display: inline;
  border-width: 0;
  border-bottom-width: 1px;
  border-color: var(--pacific);
  border-style: dotted;
  font-weight: 500;
  color: var(--pacific);
  text-decoration: none;
}
.m-card--breakout > a:visited .m-card__footer > span {
  border-color: var(--teal);
  color: var(--teal);
}
.m-card--breakout:hover .m-card__footer > span {
  border-style: solid;
  border-color: var(--pacific-dark);
  color: var(--pacific-dark);
}
.m-card--breakout > a:focus .m-card__footer > span {
  border-color: var(--pacific);
  color: var(--pacific);
}
.m-card--breakout > a:active .m-card__footer > span {
  border-color: var(--navy);
  border-style: solid;
  color: var(--navy);
}
.m-card--breakout .m-card__footer > span {
  margin-bottom: 0.6818181818em;
  font-size: 1.375em;
  font-weight: normal;
  letter-spacing: inherit;
  line-height: 1.25;
  text-transform: inherit;
}